import React from 'react'
import PropTypes from 'prop-types'
import { FormCard } from '../../../components'
import { Button, Icon } from '@salesforce/design-system-react'

const RelationshipContactForm = ({ formData, onEditButtonClicked }) => {
  return (
    <FormCard
      header='Relationship Contact'
      readOnly={true}
      icon={<Icon category='standard' name='account' />}
      form={formData}
      onInputChanged={onEditButtonClicked}
      headerActions={<Button label='Edit' onClick={onEditButtonClicked} />}
    />
  )
}

RelationshipContactForm.propTypes = {
  formData: PropTypes.object,
  onEditButtonClicked: PropTypes.func
}

export default RelationshipContactForm
